<template>
  <div>
    <HeaderView></HeaderView>
    <div class="image-container">
      <img
        src="../../public/staticImages/banner(shopwithus).png"
        class="img-fluid h-50"
        alt="Contact Image"
        style="filter: brightness(50%)"
      />
      <div
        class="text-center text-white position-absolute top-50 start-50 translate-middle"
      >
        <h1>BAR AND RESTAURANT</h1>
        <p>Home > Bar and Restaurant</p>
      </div>
    </div>

    <div
      class="container my-5"
      v-for="(data, index) in restaurants"
      :key="index"
    >
      <div class="row d-flex align-items-center" v-if="index % 2 == 0">
        <!-- Conditional check for odd number of restaurants -->
        <div class="col-lg-5">
          <h2 class="mb-4 text-center">{{ data.title }}</h2>
        </div>
        <div class="col-lg-7"></div>
        <div class="col-lg-5 text-center">
          <swiper
            :spaceBetween="30"
            :centeredSlides="true"
            :autoplay="{
              delay: 2500,
              disableOnInteraction: false,
            }"
            :pagination="{
              clickable: true,
            }"
            :modules="modules"
            class="animate__animated animate__fadeInDown animate__duration-5s"
          >
            <swiper-slide v-for="(image, index) in data.image" :key="index">
              <img :src="image" class="w-100 h-50" alt="Image Slide" />
            </swiper-slide>
          </swiper>
        </div>
        <div
          class="col-lg-7 mt-3 animate__animated animate__fadeInUp animate__duration-5s"
        >
          <p>{{ data.description }}</p>
        </div>
      </div>
      <div class="row d-flex align-items-center" v-else>
        <div class="col-lg-7"></div>
        <div class="col-lg-5">
          <h2 class="mb-4 text-center">{{ data.title }}</h2>
        </div>
        <div
          class="col-lg-7 animate__animated animate__fadeInUp animate__duration-5s"
        >
          <p>{{ data.description }}</p>
        </div>
        <!-- Conditional check for odd number of restaurants -->
        <div class="col-lg-5 text-center">
          <swiper
            :spaceBetween="30"
            :centeredSlides="true"
            :autoplay="{
              delay: 2500,
              disableOnInteraction: false,
            }"
            :pagination="{
              clickable: true,
            }"
            :modules="modules"
            class="animate__animated animate__fadeInDown animate__duration-5s"
          >
            <swiper-slide v-for="(image, index) in data.image" :key="index">
              <img :src="image" class="w-100 h-50" alt="Image Slide" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>

    <FooterView></FooterView>
  </div>
</template>

<script>
import axios from "axios";
import FooterView from "./Layouts/FooterView.vue";
import HeaderView from "./Layouts/HeaderView.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";

import { Autoplay, Pagination } from "swiper/modules";

export default {
  name: "BarRestaurantView",
  components: { HeaderView, FooterView, Swiper, SwiperSlide },
  data() {
    return {
      BaseUrl: process.env.VUE_APP_BASE_URL,
      restaurants: {},
    };
  },
  setup() {
    return {
      modules: [Autoplay, Pagination],
    };
  },
  methods: {
    async getAllRestaurants() {
      try {
        const response = await axios.get(`${this.BaseUrl}/restaurants`);
        this.restaurants = response.data.data;
        console.log(this.restaurants);
      } catch (error) {
        console.error("Error fetching bar and restaurants:", error);
      }
    },
  },
  mounted() {
    this.getAllRestaurants();
    document.title = "Bar and Restaurant - Mandalay Water Boom";
  },
};
</script>

<style scoped>
h2 {
  color: rgb(71, 141, 221);
  font-weight: bold;
}

p {
  font-size: 1.2rem;
  word-spacing: 3px;
  font-weight: 500;
}
</style>
